import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";

import type { SnackbarProps } from "./snackbar.types";

import s from "./snackbar.module.scss";

const Snackbar = ({
  show,
  message,
  theme = "dark",
  fixed,
  variant,
  actionText,
  onCloseButton,
  onActionButton,
  longerAction,
  position = "center",
  customStyles = {}
}: SnackbarProps) => {
  const positionStyles: React.CSSProperties = {
    ...(position === "left" && { left: "3.2rem", transform: "none" }),
    ...(position === "right" && {
      right: "3.2rem",
      transform: "none",
      left: "unset"
    })
  };

  const showClass = show ? " show" : "";
  const themeClass = theme === "dark" ? " snackbar-dark" : "";
  const fixedClass = fixed ? ` snackbar-fixed` : "";
  const variantClass = variant ? ` ${variant}` : "";
  const longerActionClass = longerAction ? " snackbar-longeraction" : "";

  const showActionButton = !!onActionButton && !!actionText;

  return (
    <div
      className={`snackbar${longerActionClass}${variantClass}${fixedClass}${themeClass}${showClass} ${s["snackbar_wrapper"]}`}
      style={{
        ...positionStyles,
        ...customStyles
      }}
    >
      <span className={`snackbar-text ${s["snackbar_text"]}`}>{message}</span>
      {showActionButton && (
        <button
          onClick={onActionButton}
          type="button"
          className="snackbar-actiontext"
        >
          {actionText}
        </button>
      )}
      {onCloseButton && (
        <button
          onClick={onCloseButton}
          type="button"
          className="snackbar-closebutton"
          aria-label="Fechar"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      )}
    </div>
  );
};

export default Snackbar;
